// FeaturesGrid.jsx
import React from 'react';
import './dropDownFeatures.scss';

const featureData = [
   {
      heading: 'SYSTEM FEATURES',
      items: [
         { title: 'Policy Viewer', description: 'Easily navigate and view live documents with version control' },
         { title: 'Smart Editor', description: 'Edit templates with custom content blocks while preserving compliance structure' },
         { title: 'Update Alerts', description: 'Automatic notifications for regulatory changes and updated documents' },
         { title: 'Team Access Control', description: 'Assign user roles, permissions and audit logs across your team' },
         { title: 'Audit Toolkit', description: 'Generate mock inspection checklists, evidence trackers, and audit reports' },
      ],
   },
   {
      heading: 'DOCUMENT MANAGEMENT',
      items: [
         { title: 'Document Vault', description: 'Secure central storage with tagging, version history, and expiry alerts' },
         { title: 'Onboarding Hub', description: 'Assign required documents and track progress for new services or staff' },
         { title: 'Compliance Calendar', description: 'Set reminders for audits, renewals, and document reviews' },
         { title: 'Export & Print Suite', description: 'Generate branded, inspector-ready PDFs with custom cover pages' },
      ],
   },
   {
      heading: 'INTEGRATIONS & COMPATIBILITY',
      items: [
         { title: 'CQC Compliance Sync', description: 'Link policies directly to KLOEs and inspection evidence' },
         { title: 'Third-Party Integrations', description: 'Compatible with HR software, e-learning platforms, and cloud storage' },
         { title: 'Multi-Device Support', description: 'Access your system across desktop, tablet and mobile' },
         { title: 'Help Centre', description: 'Step-by-step guides and video tutorials' },
         { title: 'Account Manager', description: 'Priority clients receive a named system success lead' },
      ],
   },
   {
      heading: 'SUBSCRIPTION FEATURES',
      items: [
         { title: 'Live Data Backup', description: 'Automatic cloud backups with 256-bit encryption' },
         { title: 'Performance Analytics', description: 'See policy usage trends, staff engagement and action completion rates' },
         { title: 'White-Label Options', description: 'Brand the platform with your logo, colours and contact info' },
         { title: 'Live Chat', description: 'Instant support during business hours' },
      ],
   },
];

export default function FeaturesModal({ isOpen, onClose, history }) {
   if (!isOpen) return null;

   const handleNavigate = () => {
      history.push('/features');
      onClose(); // Optional: close modal after navigating
   };

   return (
      <div className="features-modal-backdrop" onClick={onClose}>
         <div className="features-modal-content" onClick={(e) => e.stopPropagation()} onMouseLeave={onClose}>
            <div className="features-container">
               <div className="features-card">
                  <div className="features-grid">
                     {featureData.map((column, idx) => (
                        <div key={idx} className="feature-column">
                           <div className="feature-section">
                              <h2>{column.heading}</h2>
                              {column.items.map((item, i) => (
                                 <div key={i} className="feature-item">
                                    <h3 onClick={handleNavigate}>{item.title}</h3>
                                    <p>{item.description}</p>
                                 </div>
                              ))}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
